(function ($, Drupal, once) {

  'use strict';
  /**
   * This works with side-image class.
   */
  Drupal.behaviors.promutuel_sideImage = {
    attach: function attach(context) {

      // Get the img tag to add class on parent.
      const img = document.querySelector('.side-image img');
      // Add class to img parent.
      $(once('promutuel_sideImage', img, context)).each(function () {
        let parent = img.parentElement;
        parent.classList.add('side-image__wrapper');
      });
    }
  };
})(jQuery, Drupal, once);
